import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseById } from "../../../../../reduxToolkit/Course/coursesSpecSlice";

// core components
import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Link } from "react-router-dom";

import { Breadcrumb } from "antd";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import { fetchFieldExperienceLocations } from "../../../../../reduxToolkit/features/FieldExperienceLocations/FieldExperienceLocationsSlice";


import ErrorModal from "../../../../Components/ErrorModal";

import { useTranslation } from "react-i18next";
import DropDownButtonFieldExperienceLocation from '../../../../Components/DropDownButtonFieldExperienceLocation';

const useNavBarStyles = makeStyles(navBarStyles);

const useStyles = makeStyles(styles);

export default function FieldExperienceLocationsList({ match }) {
  const { t } = useTranslation();
  const navBarClasses = useNavBarStyles();

  const classes = useStyles();


  const { id } = match.params;
  const dispatch = useDispatch();

  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");
  const [disabledStatus, setDisabledStatus] = useState(false);

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const FieldExperienceLocationsStatus = useSelector(
    (state) => state.FieldExperienceLocation.FieldExperienceLocationsStatus
  );

  const fetchFieldExperienceLocationsByCourseId = async () => {
    try {
      const resultAction = await dispatch(
        fetchFieldExperienceLocations(id)
      ).unwrap();
      dispatch(fetchCourseById(id));
      console.log("success");
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
      console.log("err from DatesAndTimesAllocations fetch by course id", err);
    }
  };

  useEffect(() => {
    fetchFieldExperienceLocationsByCourseId();
    if (localStorage.getItem("CourseState") != "Draft") {
      setDisabledStatus(true);
    }
  }, [dispatch]);

  const course = useSelector((state) => state.CourseSpec.courseSpecification);
  const FieldExperienceLocations = useSelector(
    (state) => state.FieldExperienceLocation.FieldExperienceLocations
  );
  console.log(FieldExperienceLocations)
  console.log("course to be updated", course);

  console.log("course", course);
  console.log("FieldExperienceLocations", FieldExperienceLocations);

  let content;

  if (FieldExperienceLocationsStatus === "loading") {
    content = <div className="loader">{t("Loading...")}</div>;
  } else if (FieldExperienceLocationsStatus === "succeeded") {
    content = (
      <div>
        <GridItem>
          <Breadcrumb separator=">">
            

            <Breadcrumb.Item>
              <Link to={`/citrine/CourseSpecificationList/`}>
                {t("Courses List")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/courseSpecDetails/${course && course.id && course.id
                  }`}
              >
                {course && course.title && course.title}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/specification/course/${course && course.id && course.id}/FieldExperienceLocations`}
                style={{ color: "orange" }}
              >
                {t("Field Experience Locations List")}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>
        <GridContainer>
          <GridItem>
            {disabledStatus ? (
              <p></p>
            ) : (
              <Link
                to={`/citrine/specification/course/${course && course.id && course.id}/FieldExperienceLocations/create`}
              >
                <Button color="info" className={classes.updateProfileButton}>
                  {t("Add")}
                </Button>
              </Link>
            )}
          </GridItem>
        </GridContainer>
        <GridContainer>
          {FieldExperienceLocations &&
            FieldExperienceLocations.map((Element) => (
            
              <GridItem key={Element.id} xs={12} sm={12} md={4}>
                <Card style={{ height: 200, textAlign: "start" }}>
                  <CardBody>
                    <GridContainer xs={12} sm={12} md={12}>
                      <GridItem xs={10} sm={10} md={10}>

                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start" }}
                        >
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {t("Location")} :
                            {Element.location}
                          </a>
                        </h4>

                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start", color: "orange" }}
                        >
                          <a
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                            style={{ color: "orange" }}
                          >
                            {t("General Requirements")} : {Element.general_requirement.substring(0, 20)}
                           
                          </a>
                        </h4>


                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start" }}
                        >
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {t("Special Requirement")} :
                            {Element.special_requirement.substring(0, 20)}
                          </a>
                        </h4>





                      </GridItem>
                      <GridItem xs={2} sm={2} md={2} style={{ zIndex: 1 }}>
                        {disabledStatus ? (
                          <p></p>
                        ) : (
                          <DropDownButtonFieldExperienceLocation
                            FieldExperienceLocation_ID={Element.id}
                            courseID={course && course.id}
                          />
                        )}
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                </Card>
              </GridItem>
            ))}
        </GridContainer>
      </div>
    );
  }
  return (
    <div>
      {content}
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  );
}
